(() => {
  'use strict';
  const mobile = window.matchMedia('(max-width: 540px)');
  if (!document.documentElement.lang.toLowerCase().startsWith('en')) return;
  function update() {
    const body = document.querySelector('#shopify-pc__banner .shopify-pc__banner__body');
    if (!body) return;
    const existing = body.querySelector('.noaic-cookie-details');
    if (!mobile.matches) {
      if (existing) {
        const original = existing.querySelector('p');
        if (original) body.insertBefore(original, existing);
        body.querySelector('.noaic-cookie-short')?.remove();
        existing.remove();
        body.classList.remove('noaic-cookie-body');
      }
      return;
    }
    if (existing) return;
    const original = body.querySelector('p');
    if (!original) return;
    const short = document.createElement('p');
    short.className = 'noaic-cookie-short';
    short.append(document.createTextNode('With your consent, we and our partners use cookies for personalized content, ads and analytics. '));
    const policy = original.querySelector('a');
    if (policy) {
      const link = policy.cloneNode(true);
      link.removeAttribute('id');
      short.append(link);
    }
    const details = document.createElement('details');
    details.className = 'noaic-cookie-details';
    const summary = document.createElement('summary');
    summary.textContent = 'Details';
    summary.setAttribute('aria-label', 'Full cookie information');
    details.append(summary);
    body.insertBefore(short, original);
    body.append(details);
    details.append(original);
    body.classList.add('noaic-cookie-body');
  }
  update();
  mobile.addEventListener('change', update);
  new MutationObserver(update).observe(document.body, {childList: true, subtree: true});
})();